import React from "react";
import { JSONTree } from "react-json-tree";
import greenCircle from "../../../assets/images/greenCircle.svg";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { ListSubheader, Typography } from "@mui/material";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { parseFontCheck, getStatusIcon, getStatusColor } from './utils/MetadataUtils';
import StatusRow from './utils/StatusRow';
import { renderCreateModifiedDates } from './utils/DateUtils';
import FontCheckResult from './FontCheckResult';
import {
  getFurtherVerificationDisplay,
  getMetadataDisplayStatus,
  isNoRuleMetadataParadigm,
  splitMetadataRule,
} from './utils/metadataRuleUtils';

const Dark = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const checkCreateandModifiedDate = (dateString: string) => {
  return renderCreateModifiedDates(dateString);
}

const NewMetaDataRules = ({
  metaDataCheck,
  alignmentError,
  unknownTemplate,
  fraudTemplate,
  docStateType,
}) => {
  const LABEL_WIDTH = 160;
  const LABEL_MARGIN_RIGHT = 24;
  const STATUS_WIDTH = 100;
  const STATUS_MARGIN_RIGHT = 3;
  const labelStyle = { fontSize: '10px', minWidth: `${LABEL_WIDTH}px`, maxWidth: `${LABEL_WIDTH}px`, marginRight: `${LABEL_MARGIN_RIGHT}px` };
  const statusStyle = { fontSize: '9px', minWidth: `${STATUS_WIDTH}px`, maxWidth: '120px', marginRight: `${STATUS_MARGIN_RIGHT}px` };
  const formatStatusText = (status?: string) => status === 'NA' ? 'No Rule' : status || '';
  const noRuleParadigmActive = isNoRuleMetadataParadigm(metaDataCheck, docStateType);
  return (<><div className="row" >
    {metaDataCheck.length > 0 && <div className="col-12 col-lg-12 col-md-12">
      <div>
        <div className="border-bottom small mb-2" style={{ fontSize: '10px' }}><strong>Metadata Check</strong></div>

        {metaDataCheck.map((item, index) => {
          const { ruleName: rawRuleName, ruleValue } = splitMetadataRule(item.rule);
          const ruleName = rawRuleName === 'File Size'
            ? 'File Size Check'
            : rawRuleName === 'Further Verification'
              ? 'Further Verification Check'
              : rawRuleName;
          const parsedFonts = ruleName === 'Font Check' ? parseFontCheck(ruleValue) : null;
          const displayStatus = getMetadataDisplayStatus(
            item.status,
            docStateType,
            rawRuleName,
            ruleValue,
            noRuleParadigmActive
          );
          const statusIcon = getStatusIcon(displayStatus);
          const statusColor = getStatusColor(displayStatus);
          const statusText = formatStatusText(displayStatus);
          const furtherVerificationDisplay = getFurtherVerificationDisplay(item.status, ruleValue);

          const isFontCheck = ruleName == 'Font Check';
          const rowStyle = { flexWrap: isFontCheck ? 'nowrap' : 'wrap' } as const;
          const fontCheckContentStyle: React.CSSProperties = {
            fontSize: '10px',
            minWidth: '200px',
            flex: '1 1 0',
            minHeight: '100%',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            whiteSpace: 'pre-wrap',
          };

          return (<div className="d-flex align-items-start py-1" style={rowStyle} key={`${ruleName}-${index}`}>
            <div style={labelStyle}>{ruleName}</div>
            <div className="d-flex align-items-center" style={statusStyle}>
              <strong>{statusText}</strong>
            </div>
            {isFontCheck && parsedFonts && <div className="flex-grow-1" style={fontCheckContentStyle}>
              <FontCheckResult parsedFonts={parsedFonts} rawRule={ruleValue} />
            </div>}
            {ruleName != 'Font Check' && <div className="flex-grow-1" style={{ fontSize: '10px', minWidth: '200px' }}>
              <StatusRow statusIcon={statusIcon} color={statusColor}>
                {ruleName === 'Further Verification Check'
                  ? furtherVerificationDisplay
                  : checkCreateandModifiedDate(ruleValue)}
              </StatusRow>
            </div>}
          </div>)
        })}
      </div>
    </div>}
    {alignmentError.length > 0 && <div className="col-12 col-lg-12 col-md-12 pt-4">
      <div>
        <div className="border-bottom small mb-2" style={{ fontSize: '10px' }}><strong>Allignment Error Check</strong></div>

        {alignmentError.map((item, idx) => {
          const statusText = formatStatusText(item.status);
          return (<div className="d-flex align-items-start flex-wrap py-1" key={`align-${idx}`}>
            <div style={labelStyle}>{item.rule}</div>
            <div className="d-flex align-items-center" style={statusStyle}>
              <strong>{statusText}</strong>
            </div>
          </div>)
        })}
      </div>
    </div>}
  </div>
    <br />
    <div className="row ">
      {unknownTemplate.length > 0 && <div className="col-12 col-lg-12 col-md-12 mb-4">
        <div>
          <div className="border-bottom small mb-2" style={{ fontSize: '10px' }}><strong>Unknown Template Check</strong></div>

          {unknownTemplate.map((item, idx) => {
            const statusText = formatStatusText(item.status);
            return (<div className="d-flex align-items-start flex-wrap py-1" key={`unknown-${idx}`}>
              <div style={labelStyle}>{item.rule}</div>
              <div className="d-flex align-items-center" style={statusStyle}>
                <strong>{statusText}</strong>
              </div>
            </div>)
          })}
        </div>
      </div>}
      {fraudTemplate.length > 0 && <div className="col-12 col-lg-12 col-md-12">
        <div>
          <div className="border-bottom small mb-2" style={{ fontSize: '10px' }}><strong>Fraud Template Check</strong></div>

          {fraudTemplate.map((item, idx) => {
            const statusText = formatStatusText(item.status);
            return (<div className="d-flex align-items-start flex-wrap py-1" key={`fraud-${idx}`}>
              <div style={labelStyle}>{item.rule}</div>
              <div className="d-flex align-items-center" style={statusStyle}>
                <strong>{statusText}</strong>
              </div>
            </div>)
          })}
        </div>
      </div>}
    </div></>)
};

export default NewMetaDataRules;
